/**
 * Walks the widget config tree recursively, applying a callback to each widget config.
 *
 * @template Config - A config type extending WidgetConfigBase.
 * @param {Config} config - The root widget configuration to begin traversal from.
 * @param {Widget<any, any>[]} widgets - The list of available widget definitions.
 * @param {(config: WidgetFormConfigBase, widget: Widget<any, any>, param?: any) => any | undefined | void} callback - A callback function applied to each widget config in the tree.
 * @param {any} [param] - Optional parameter passed to each recursive callback invocation.
 * @returns {void}
 */
export function walkWidgetConfigTree(config, widgets, callback, param) {
    const widgetMap = {};
    for (const widget of widgets) {
        widgetMap[widget.type] = widget;
    }
    walkWidgetConfigTreeRecursive(config, widgetMap, callback, param);
}
function walkWidgetConfigTreeRecursive(config, widgetMap, callback, param) {
    const widget = widgetMap[config.type];
    if (widget) {
        param = callback(config, widget, param);
        if (widget.childConfigs) {
            for (const childConfig of widget.childConfigs(config)) {
                walkWidgetConfigTreeRecursive(childConfig, widgetMap, callback, param);
            }
        }
    }
}
